import { useEffect, useState } from "react";
import { AssignmentProps } from "@/interfaces/assignment_types";
import { TaskProps } from "@/interfaces/tasks_types";
import { AssignmentOuterContainer } from "./Components/AssignmentOuterContainer";
import { SectionDiv } from "./Components/SectionDiv";
import { TaskOuterContainer } from "./Components/TaskOuterContainer";

type TaskSectionProps = {
	sorted_tasks: TaskProps[];
	sorted_assignments: AssignmentProps[];
	isNewCard: (cardType: string, id: string) => boolean;
	markAsSeen: (cardType: string, id: string) => void;
};

export function TaskSection({
	sorted_tasks,
	sorted_assignments,
	isNewCard,
	markAsSeen,
}: TaskSectionProps) {
	const [tasksByProject, setTasksByProject] = useState<
		Record<string, TaskProps[]>
	>({});
	const [assignements, setAssignements] = useState<AssignmentProps[]>([]);

	useEffect(() => {
		setTasksByProject(GroupTasksByProject(sorted_tasks));
		setAssignements(sorted_assignments);
	}, []);
	// No dependencies, so it will only run once (this will cause a loop if you add the sorted_tasks and sorted_assignments to the dependencies)

	return (
		<SectionDiv>
			<h3>My Tasks:</h3>

			<div className="overflow-y-auto h-full pb-4">
				{assignements.length > 0 && (
					<AssignmentOuterContainer
						key={"Assignments"}
						projectName={"Assignments"}
						assignments={assignements}
						isNewCard={isNewCard}
						markAsSeen={markAsSeen}
						folderLocation={""}
					/>
				)}

				{Object.entries(tasksByProject).length > 0 ? (
					Object.entries(tasksByProject)
						.sort((a, b) => a[0].localeCompare(b[0]))
						.map(([projectName, tasks]) => (
							<TaskOuterContainer
								key={projectName}
								projectName={projectName}
								tasks={tasks}
								isNewCard={isNewCard}
								markAsSeen={markAsSeen}
								folderLocation={tasks[0].folder_location ?? ""}
							/>
						))
				) : (
					<h3>No Tasks assigned to you</h3>
				)}
			</div>
		</SectionDiv>
	);
}

const GroupTasksByProject = (tasks: TaskProps[]) => {
	return tasks.reduce(
		(result, task) => {
			const projectName = task.project || "No Project";

			if (!result[projectName]) {
				result[projectName] = [];
			}

			result[projectName].push(task);
			return result;
		},
		{} as Record<string, TaskProps[]>,
	);
};

